/***
 * Model that represents a System Message.
 */
import Backbone from 'backbone';

var SystemMessage = Backbone.Model.extend({
    idAttribute: 'value',

    urlRoot: function() {
        return '/modern/system-service/preference/SystemPreferenceDisplay.systemMessage';
    },

    parse: function(response) {
        return response;
    }
});

export default SystemMessage;
